import React, { useState } from 'react';
import { Flex } from 'antd';
import DisplayTimeDropdown from '@/pages/Shipments/MapExternalView/DisplayTimeDropdown';
import { DisplayTimeSelection } from '@/pages/Shipments/MapExternalView/types';
import { DateSetEntries } from './dateSetTypes';
import styles from './SelectedEntriesHeader.module.css';

interface SelectedEntriesHeaderProps {
  kind: DateSetEntries['kind'];
  count: number;
  timezoneValue: DisplayTimeSelection;
  onTimezoneChange: (sel: DisplayTimeSelection) => void;
}

/** The row above a chip list: "Selected dates (N)" / "Selected days (N)" on
 * the left, the timezone selector on the right. */
const SelectedEntriesHeader: React.FC<SelectedEntriesHeaderProps> = ({
  kind,
  count,
  timezoneValue,
  onTimezoneChange,
}) => {
  const [tzOpen, setTzOpen] = useState(false);

  return (
    <Flex justify='space-between' align='center'>
      <span className={`font-12 lh-16 fw-600 ${styles.label}`}>
        {kind === 'dates' ? 'Selected dates' : 'Selected days'} ({count})
      </span>
      <div className={styles.timezone}>
        <DisplayTimeDropdown
          value={timezoneValue}
          onChange={onTimezoneChange}
          open={tzOpen}
          setOpen={setTzOpen}
          hideLocalScanTime
          hideMyBrowserTime={false}
          // A DateTimeSetExpr timezone is a plain IANA string, so the
          // shipment-relative origin/destination sentinels can't be resolved.
          disabledKeys={['origin', 'destination']}
          label={null}
        />
      </div>
    </Flex>
  );
};

export default SelectedEntriesHeader;
